import { render, staticRenderFns } from "./AppPdfViewer.vue?vue&type=template&id=b41b406c&scoped=true"
import script from "./AppPdfViewer.vue?vue&type=script&lang=js"
export * from "./AppPdfViewer.vue?vue&type=script&lang=js"
import style0 from "./AppPdfViewer.vue?vue&type=style&index=0&id=b41b406c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41b406c",
  null
  
)

export default component.exports